import type { ProjectUserRole } from '@si/types';
import { post } from '@si/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryKeys } from './queryKeys';

interface Params {
  projectId: string;
  userProjectId: string;
  role: ProjectUserRole;
  expiryDate?: string | null;
}

export function useUpdateProjectUser() {
  const queryClient = useQueryClient();

  const { mutate, error, isPending, isSuccess, reset } = useMutation({
    mutationFn: (params: Params) =>
      post({
        url: `/projects/${params.projectId}/team/update`,
        body: params,
      }),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.getProjectUsers(variables.projectId),
      });
    },
  });

  const updateProjectUser = useCallback((params: Params) => mutate(params), [mutate]);

  return {
    updateProjectUser,
    error,
    isPending,
    isSuccess,
    reset,
  };
}
